import { atom, selector } from "recoil"
import { draftSelector } from "src/recoil/selectors/contact/draftSelector"
import { templateSelector } from "src/recoil/selectors/contact/templateSelector"
import { existingContactDetailSelector } from "src/recoil/selectors/contact/create/existingContactDetailSelector"
import { migrationSelector } from "src/recoil/selectors/contact/migrationSelector"
import { reservedSelector } from "src/recoil/selectors/contact/reservedSelector"

const initialState = true

const initialStateSelector = selector({
  key: "atoms/contact/create/isAddToOtherAdminsHistoryState_initialState",
  get: ({ get }) => {
    const contact = get(existingContactDetailSelector)
    const reserved = get(reservedSelector)
    const template = get(templateSelector)
    const draft = get(draftSelector)
    const migration = get(migrationSelector)
    if (reserved) {
      const val = reserved.isAddToOtherAdminsHistory
      return val === undefined ? true : !val
    }
    return (contact ?? reserved ?? template ?? draft ?? migration)?.isAddToOtherAdminsHistory ?? initialState
  },
})

export const isAddToOtherAdminsHistoryState = atom({
  key: "atoms/contact/create/isAddToOtherAdminsHistoryState",
  default: initialStateSelector,
})

const initialEnableForCommentState = true

const initialEnableForCommentStateSelector = selector({
  key: "atoms/contact/create/isEnableForCommentState_initialState",
  get: ({ get }) => {
    const contact = get(existingContactDetailSelector)
    const reserved = get(reservedSelector)
    const template = get(templateSelector)
    const draft = get(draftSelector)
    const migration = get(migrationSelector)
    return (contact ?? reserved ?? template ?? draft ?? migration)?.isEnableForComment ?? initialEnableForCommentState
  },
})

export const isEnableForCommentState = atom({
  key: "atoms/contact/create/isEnableForCommentState",
  default: initialEnableForCommentStateSelector,
})
